import { useMapContext } from "../../contexts/MapContext"

import { Legend, LegendProps } from "../Legend"

type MapLegendProps = Omit<LegendProps, "openByDefault" | "onToggleLegend">

export function MapLegend(props: MapLegendProps) {

    const {
        displayedLegends,
    } = props

    const [mapState, mapDispatch] = useMapContext()
    const { legendOpened } = mapState
    const { toggleLegendOpening } = mapDispatch

    return <Legend
        displayedLegends={displayedLegends}
        openByDefault={legendOpened}
        onToggleLegend={toggleLegendOpening}
    />
}